import { render, staticRenderFns } from "./CoursesCalendarView.vue?vue&type=template&id=3f63bf1a&"
import script from "./CoursesCalendarView.vue?vue&type=script&lang=ts&"
export * from "./CoursesCalendarView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports